export default "__VITE_ASSET__CgkeJc23__"